import { PriceRow } from 'components/Product/ProductPrice';
import React, { CSSProperties, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Language, Product } from 'types/schema';
import utilsMessages from 'utils/messages';
import formatMoney from '../../../utils/formatMoney';

export const PriceText = styled.p`
  color: #595959;
  font-size: 16px;
  font-weight: 700;
`;

const VAT = styled.p`
  font-family: 'Inter';
  font-size: 12px;
  font-weight: 500;
  color: #585a60;
  font-style: italic;
`;

export interface PriceProps {
  style?: CSSProperties;
  product: Product;
  baseUom?: string;
  baseUomPrice?: number;
  netUom?: string;
  uom?: string;
  lang?: Language;
}

const PriceContainer = styled.div`
  height: 54px;
  margin-top: 5px;
`;

const DiscountPrice = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #3c9041;
`;
const PerPrice = styled.p`
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  color: #808289;
`;
const BasePrice = styled.p`
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
  color: #aaacb2;
  text-decoration: line-through;
`;

export const Price = ({ product, baseUomPrice, baseUom, netUom }: PriceProps) => {
  const { price, originalPrice, netUomPrice, baseUnit, netUnit } = product;

  const renderUomPrice = useMemo(() => {
    if (baseUomPrice && baseUnit !== 1) {
      return (
        <PerPrice>
          ({formatMoney(baseUomPrice, 1)}đ/{baseUom})
        </PerPrice>
      );
    }

    if (netUomPrice && netUnit !== 1) {
      return (
        <PerPrice>
          ({formatMoney(netUomPrice, 1)}đ/{netUom})
        </PerPrice>
      );
    }
    return '';
  }, [baseUomPrice, baseUom, netUomPrice, netUom]);

  return (
    <PriceContainer>
      <PriceRow>
        <DiscountPrice>
          {formatMoney(price)}
          <span style={{ fontSize: 14 }}>đ</span>
        </DiscountPrice>
        {originalPrice > price ? <BasePrice>{formatMoney(originalPrice)}đ</BasePrice> : null}
      </PriceRow>
      {renderUomPrice}
      <VAT>
        (<FormattedMessage {...utilsMessages.vatProductPrice} />)
      </VAT>
    </PriceContainer>
  );
};
